import React, { useState } from 'react';
import AdminLayout from '../../../layouts/AdminLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import ClientSlider from '../../../components/slider/ClientSlider';

const defaultClientLogos = [
    "../assets/img/client_logo_1.png",
    "../assets/img/client_logo_2.png",
    "../assets/img/client_logo_3.png",
    "../assets/img/client_logo_4.png",
    "../assets/img/client_logo_5.png",
    "../assets/img/client_logo_6.png",
    "../assets/img/client_logo_7.png",
    "../assets/img/client_logo_8.png",
];

const AddServices = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [clientLogoSlots, setClientLogoSlots] = useState(defaultClientLogos);

    const [templateData, setTemplateData] = useState({
        section1: {
            heading: "Supercharge Your Sales Success",
            body: "At Nuvio, we help you close deals faster, reach the right customers, and unlock growth with expert-driven sales solutions."
        },
        // section2: {
        //     heading: "Facing These Sales Roadblocks? Let’s Clear the Way to Bigger Wins!",
        //     body: "Struggling to generate quality leads You’re chasing cold prospects or waiting on unpredictable inbound but the right, high- potential leads aren’t flowing in Mixed - up messaging across the team Your sales materials, pitches, and presentations tell different stories, making it harder to earn trust and stand out. Wasting time, not closing deals Your sales team burns hours hunting for resources, approvals, or tools — instead of focusing on what matters: closing. Missing growth targets Even with all the hustle, revenue goals stay out of reach because there’s no clear plan, insights, or scalable strategy."
        // },
        section2: {
            heading: "Facing These Sales Roadblocks? Let’s Clear the Way to Bigger Wins!",
            points: [
                {
                    title: "Mixed-up messaging across the team",
                    description:
                        "Your sales materials, pitches, and presentations tell different stories, making it harder to earn trust and stand out."
                },
                {
                    title: "Wasting time, not closing deals",
                    description:
                        "Your sales team burns hours hunting for resources, approvals, or tools — instead of focusing on what matters: closing."
                },
                {
                    title: "Missing growth targets",
                    description:
                        "Even with all the hustle, revenue goals stay out of reach because there’s no clear plan, insights, or scalable strategy."
                }
            ]
        },
        section3: {
            header: "Why isn’t my sales team hitting targets?",
            body: "Hard work alone isn’t enough. Nuvio helps refine strategy, target the right leads, and close smarter",
        },
        section4: {
            box1: "75%",
            title1: "of companies face it. We help you attract the right leads.",
            box2: "60%",
            title2: "of sales reps do. We automate tasks so they can sell more.",
            box3: "80%",
            title3: "of B2B sales are delayed. We align your messaging and tools for faster results.",
        },
        section5: {
            // heading: "Empower Your Sales Teams to Sell Bigger, Faster, and Smarter with Nuvio",
            title1: "Focus on What Really Drives Revenue",
            description1: "Not all leads are created equal. With Nuvio, your sales team can confidently prioritize the prospects that bring the biggest wins, avoiding wasted effort and zeroing in on the opportunities that truly move the needle for your business.",
            title2: "Smooth Out the Entire Sales Journey",
            description2: "Say goodbye to clunky handoffs, scattered tasks, and pipeline slowdowns. Nuvio streamlines every step of the sales process, helping your team glide from first contact to closed deal with clarity, speed, and efficiency every time.",
            title3: "Empower Your Reps to Close with Confidence",
            description3: "Winning sales teams don’t just work hard they work smart. Nuvio equips your reps with the right tools, insights, and support so they show up ready, pitch with confidence, and consistently outperform the competition.",
        },
        section6: {
            heading: "Sales Packages Designed for Growth",
            body: "From lean startups to scaling teams, choose a package that fits your sales goals with the tools, support, and strategy to help you close with confidence.",
            plan1_title: "Starter Plan",
            plan1_price: `$30`,
            plan1_description: "Perfect for short-term goals",
            plan1_points: [
                "Access to all core sales features",
                "Basic performance reporting",
                "Email support",
                "Flexible for pilot projects"
            ],
            plan2_title: "Pro Plan",
            plan2_price: `$100`,
            plan2_description: "Ideal for growing teams ready to scale",
            plan2_points: [
                "Everything in 6-month plan",
                "Advanced CRM integration",
                "Quarterly strategy check-ins",
                "Priority support"
            ],
            plan3_title: "Enterprise Plan",
            plan3_price: `$150`,
            plan3_description: "For teams committed to long-term sales",
            plan3_points: [
                "Everything in 1-year plan",
                "Dedicated success manager",
                "Annual performance reviews",
                "Custom optimization support"
            ],
        },
        section7: {
            box1_heading: "Empower Teams with Smarter Sales Solutions",
            box1_point1: "Focus on high-value prospects, prioritize top opportunities, and drive meaningful growth.",
            box1_point2: "Automate routine tasks, eliminate bottlenecks, and free up your team to focus on closing deals",
            box1_point3: "Keep all material and tools in one place, creating a single source of truth your team can trust.",
            box2_heading: "Accelerate Sales Performance with the Right Tools",
            box2_point1: "Equip your team with powerful tools that simplify every stage of the sales journey.",
            box2_point2: "Gain real-time insights to track progress, adjust strategies, and stay ahead of the competition.",
            box2_point3: "Deliver a seamless experience across teams, ensuring everyone works toward the same goals with clarity and precision.",
            box3_heading: "Unlock Sales Innovation to Stay Ahead",
            box3_point1: "Adopt forward-thinking strategies that help your team adapt in a fast-changing market.",
            box3_point2: "Leverage cutting-edge tools and insights to uncover new growth opportunities.",
            box3_point3: "Continuously evolve your sales approach to outpace competitors and deliver exceptional value.",
        },
        section8: {
            faqs: [
                {
                    question: "Accelerated Deal Velocity",
                    answer:
                        "Sign up for an account, complete your profile, and browse our directory of coaches. You can filter by expertise, experience, and coaching style to find the best match for your needs.",
                },
                {
                    question: "Smarter, Data-Backed Decisions",
                    answer:
                        "NUVIO offers a wide range of coaching, including career coaching, business and entrepreneurship coaching, creative and design coaching, personal development, and skills-specific coaching like Creative AI or freelance growth.",
                },
                {
                    question: "Empowered, High-Performing Teams",
                    answer:
                        "Once you’ve found a coach that fits your needs, you can book a session directly through their profile. Choose a time that works for you, confirm your booking, and receive a session link or meeting details.",
                },
                {
                    question: "Scalable Success, Every Step",
                    answer:
                        "Review the coach’s profile, experience, and specialties. Many coaches offer introductory calls or discovery sessions so you can assess compatibility before committing to a full program.",
                }
            ],
        },
    });

    const [imageFiles, setImageFiles] = useState({
        header: null,
        faq: null,
        video: null,
        serviceImages: [null, null, null, null],
        clientLogos: Array(clientLogoSlots.length).fill(null),
    });

    const handleChangeValue = (e, field, data) => {
        setTemplateData((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                [data]: e.target.innerText,
            },
        }));
    };

    const handleImageChange = (e, type, index = null) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setImageFiles((prev) => {
            if (index !== null && Array.isArray(prev[type])) {
                const updatedArray = [...prev[type]];
                updatedArray[index] = file;
                return {
                    ...prev,
                    [type]: updatedArray,
                };
            }

            return {
                ...prev,
                [type]: file,
            };
        });
    };

    const getImageSrc = (file, fallbackPath) =>
        file ? URL.createObjectURL(file) : fallbackPath;
    const clientSliderLogos = imageFiles.clientLogos
        ?.map((file, index) => getImageSrc(file, clientLogoSlots[index]))
        ?.filter(Boolean);

    const handleAddClientLogo = () => {
        setClientLogoSlots((prev) => [...prev, ""]);
        setImageFiles((prev) => ({
            ...prev,
            clientLogos: [...prev.clientLogos, null],
        }));
    };

    const handleRemoveClientLogo = (index) => {
        setClientLogoSlots((prev) => prev.filter((_, i) => i !== index));
        setImageFiles((prev) => ({
            ...prev,
            clientLogos: prev.clientLogos.filter((_, i) => i !== index),
        }));
    };

    const handleFaqChange = (index, field, value) => {
        setTemplateData((prevData) => ({
            ...prevData,
            section8: {
                ...prevData.section8,
                faqs: prevData.section8.faqs.map((faq, i) =>
                    i === index ? { ...faq, [field]: value } : faq
                ),
            },
        }));
    };

    const handleAddFaq = () => {
        setTemplateData((prevData) => ({
            ...prevData,
            section8: {
                ...prevData.section8,
                faqs: [
                    ...prevData.section8.faqs,
                    { question: "Enter Question", answer: "Enter Answer" },
                ],
            },
        }));
    };

    const handleDeleteFaq = (index) => {
        setTemplateData((prevData) => ({
            ...prevData,
            section8: {
                ...prevData.section8,
                faqs: prevData.section8.faqs.filter((_, i) => i !== index),
            },
        }));
    };

    const handleSection2Change = (index, field, value) => {
        setTemplateData((prev) => ({
            ...prev,
            section2: {
                ...prev.section2,
                points: prev.section2.points.map((item, i) =>
                    i === index ? { ...item, [field]: value } : item
                )
            }
        }));
    };

    const handleAddSection2Point = () => {
        setTemplateData((prev) => ({
            ...prev,
            section2: {
                ...prev.section2,
                points: [
                    ...prev.section2.points,
                    {
                        title: "Enter Title",
                        description: "Enter Description"
                    }
                ]
            }
        }));
    };

    const handleDeleteSection2Point = (index) => {
        setTemplateData((prev) => ({
            ...prev,
            section2: {
                ...prev.section2,
                points: prev.section2.points.filter((_, i) => i !== index)
            }
        }));
    };

    const handleAddPlanPoint = (planKey) => {
        setTemplateData((prev) => ({
            ...prev,
            section6: {
                ...prev.section6,
                [planKey]: [...prev.section6[planKey], "Enter point"]
            }
        }));
    };

    const handleDeletePlanPoint = (planKey, index) => {
        setTemplateData((prev) => ({
            ...prev,
            section6: {
                ...prev.section6,
                [planKey]: prev.section6[planKey].filter((_, i) => i !== index)
            }
        }));
    };

    return (
        <>
            <AdminLayout>
                <section class="ct_workshop_banner ct_px_40 py-4">
                    <div class="container-fluid">
                        <div class="row align-items-center">
                            <div
                                class="col-lg-7 mb-4 mb-lg-0"
                                data-aos="fade-right"
                                data-aos-duration="3000"
                            >
                                <h2
                                    contentEditable="true"
                                    suppressContentEditableWarning
                                    onBlur={(e) => handleChangeValue(e, "section1", "heading")}
                                    class="ct_fs_50_new mb-4 ct_darkblue_text"
                                    style={{ maxWidth: "560px" }}
                                >
                                    Supercharge Your Sales
                                    Success
                                </h2>
                                <p
                                    class="mb-0 ct_fs_20 ct_darkblue_text"
                                    style={{ maxWidth: "613px" }}
                                    contentEditable="true"
                                    suppressContentEditableWarning
                                    onBlur={(e) => handleChangeValue(e, "section1", "body")}
                                >
                                    At Nuvio, we help you close deals faster, reach the right
                                    customers, and unlock growth with expert-driven sales solutions.
                                </p>
                                <div class="ct_mt_40">
                                    <a
                                        class="ct_yellow_btn px-5 ct_fit_content"
                                    >
                                        Pick Your Plan
                                    </a>
                                </div>
                            </div>
                            <div
                                class="col-lg-5 mb-4 mb-lg-0"
                                data-aos="fade-left"
                                data-aos-duration="1000"
                            >
                                <div class="ct_workshop_right_img">
                                    <label>
                                        <input
                                            className="d-none"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleImageChange(e, "header")}
                                        />
                                        <img
                                            src={getImageSrc(
                                                imageFiles.header,
                                                "../assets/img/services_right_img_1234.png"
                                            )}
                                            style={{ maxWidth: "100%" }}
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ct_py_65 pb-0">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="ct_fs_24_new mb-4 text-center">
                                    Join the 1,200+ companies growing with us{" "}
                                </h4>
                                <ClientSlider logos={clientSliderLogos} />
                                <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
                                    {clientLogoSlots.map((logo, index) => (
                                        <div key={`client-logo-${index}`} className="position-relative">
                                            <label className="ct_cursor_pointer mb-0" title={`Upload logo ${index + 1}`}>
                                                <input
                                                    className="d-none"
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => handleImageChange(e, "clientLogos", index)}
                                                />
                                                {imageFiles.clientLogos[index] || logo ? (
                                                    <img
                                                        src={getImageSrc(imageFiles.clientLogos[index], logo)}
                                                        alt={`Client logo ${index + 1}`}
                                                        style={{
                                                            width: "90px",
                                                            height: "48px",
                                                            objectFit: "contain",
                                                            border: "1px solid #E5E5E5",
                                                            borderRadius: "6px",
                                                            padding: "6px",
                                                            backgroundColor: "#fff",
                                                        }}
                                                    />
                                                ) : (
                                                    <div
                                                        style={{
                                                            width: "90px",
                                                            height: "48px",
                                                            border: "1px dashed #BFBFBF",
                                                            borderRadius: "6px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: "12px",
                                                            color: "#666",
                                                            backgroundColor: "#fff",
                                                        }}
                                                    >
                                                        Upload
                                                    </div>
                                                )}
                                            </label>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger position-absolute top-0 start-100 translate-middle p-0"
                                                style={{ width: "20px", height: "20px", lineHeight: "18px" }}
                                                onClick={() => handleRemoveClientLogo(index)}
                                                aria-label={`Remove logo ${index + 1}`}
                                            >
                                                x
                                            </button>
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        className="btn btn-outline-dark btn-sm"
                                        onClick={handleAddClientLogo}
                                    >
                                        + Add Logo
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class=" ct_py_100  ct_px_162 ">
                    <div class="container-fluid">
                        <div class="row">
                            <div
                                class="col-lg-5 mb-4 mb-lg-0"
                                data-aos="fade-right"
                                data-aos-duration="1500"
                            >
                                <div class="ct_img_unlock_img_23">
                                    <div class="ct_img_unlock_img_23_left">
                                        <label>
                                            <input
                                                className="d-none"
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, "serviceImages", 0)}
                                            />
                                            <img
                                                src={getImageSrc(
                                                    imageFiles.serviceImages[0],
                                                    "../assets/img/Image_1101.png"
                                                )}
                                                style={{ maxWidth: "100%" }}
                                            />
                                        </label>
                                        <label>
                                            <input
                                                className="d-none"
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, "serviceImages", 1)}
                                            />
                                            <img
                                                src={getImageSrc(
                                                    imageFiles.serviceImages[1],
                                                    "../assets/img/gir_Image_3@2x.png"
                                                )}
                                                alt=""
                                            />
                                        </label>
                                    </div>
                                    <div class="ct_img_unlock_img_23_right">
                                        <label>
                                            <input
                                                className="d-none"
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, "serviceImages", 2)}
                                            />
                                            <img
                                                src={getImageSrc(
                                                    imageFiles.serviceImages[2],
                                                    "../assets/img/Image_1102.png"
                                                )}
                                                alt=""
                                            />
                                        </label>
                                        <label>
                                            <input
                                                className="d-none"
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, "serviceImages", 3)}
                                            />
                                            <img
                                                src={getImageSrc(
                                                    imageFiles.serviceImages[3],
                                                    "../assets/img/Image_1104.png"
                                                )}
                                                alt=""
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-lg-6 ps-lg-5 mb-4 mb-lg-0 "
                                data-aos="fade-left"
                                data-aos-duration="1500"
                            >
                                <h4
                                    class="ct_fs_32 ct_darkblue_text mb-0"
                                    style={{ maxWidth: "512px" }}
                                    contentEditable="true"
                                    suppressContentEditableWarning
                                    onBlur={(e) => handleChangeValue(e, "section2", "heading")}
                                >
                                    {templateData?.section2?.heading || ""}
                                </h4>
                                <ul className="ct_pt_40">

                                    {templateData?.section2?.points?.map((item, index) => (

                                        <div className="d-flex align-items-start gap-2" key={index}>

                                            <li className="mt-4 ct_flex_1">

                                                <h4
                                                    className="ct_fs_20 ct_darkblue_text mb-2"
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleSection2Change(index, "title", e.target.innerText)}
                                                >
                                                    {item.title}
                                                </h4>

                                                <p
                                                    className="mb-0 ct_fs_16"
                                                    style={{ maxWidth: "507px" }}
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleSection2Change(index, "description", e.target.innerText)}
                                                >
                                                    {item.description}
                                                </p>

                                            </li>

                                            {templateData.section2.points.length > 1 && (
                                                <i
                                                    className="fa-solid fa-trash text-danger ct_cursor_pointer mt-4"
                                                    onClick={() => handleDeleteSection2Point(index)}
                                                ></i>
                                            )}

                                        </div>

                                    ))}

                                    <div className="text-end mt-3">
                                        <span
                                            className="ct_orange_text ct_fw_600 ct_cursor_pointer"
                                            onClick={handleAddSection2Point}
                                        >
                                            + Add Point
                                        </span>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ct_px_40 pt-0">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ct_video_section">
                                    <div className="ct_video_section_img position-relative">
                                        <label className="d-block position-relative" style={{ cursor: "pointer", zIndex: 2 }}>
                                            <input
                                                type="file"
                                                className="d-none"
                                                accept="video/*"
                                                onChange={(e) => handleImageChange(e, "video")}
                                            />
                                            {imageFiles.video ? (
                                                <video
                                                    src={URL.createObjectURL(imageFiles.video)}
                                                    controls={false}
                                                    autoPlay
                                                    style={{ width: "100%" }}
                                                />
                                            ) : (
                                                <img
                                                    src="../assets/img/video_bg_345.png"
                                                    style={{ width: "100%" }}
                                                />
                                            )}
                                        </label>
                                    </div>
                                    {/* <div className="ct_video_section_img">
                                        <label className="d-block">
                                            <input
                                                type="file"
                                                className="d-none"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, "video")}
                                            />
                                            <img
                                                src={getImageSrc(
                                                    imageFiles.video,
                                                    "../assets/img/video_bg_345.png"
                                                )}
                                                style={{ width: "100%" }}
                                            />
                                        </label>
                                    </div> */}
                                    <div className="ct_video_overlay_content text-center">
                                        <div className="ct_play_icon mb-3">
                                            <i className="fa-solid fa-play"></i>
                                        </div>
                                        <h4
                                            className="ct_fs_32 text-white mb-3"
                                            contentEditable
                                            suppressContentEditableWarning
                                            onBlur={(e) =>
                                                handleChangeValue(e, "section3", "header")
                                            }
                                        >
                                            {templateData?.section3?.header || ""}
                                        </h4>
                                        <p
                                            className="mb-0 mx-auto text-white ct_text_op_6"
                                            style={{ maxWidth: "500px" }}
                                            contentEditable
                                            suppressContentEditableWarning
                                            onBlur={(e) =>
                                                handleChangeValue(e, "section3", "body")
                                            }
                                        >
                                            {templateData?.section3?.body || ""}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ct_px_40 ct_pt_65_pb_62">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="ct_fs_32 ct_darkblue_text text-center">
                                    Together, We Achieve More
                                </h4>
                            </div>
                        </div>
                        <div className="row ct_mt_60 gx-5">
                            <div className="col-lg-4 mb-4">
                                <div className="ct_outline_bg bg-white ct_pb_86 h-100">
                                    <figure className="ct_pt_40 text-center">
                                        <img src="../assets/img/ph_magnifying-glass-fill.png" />
                                        <figcaption className="ct_mt_60">
                                            <h3
                                                className="ct_fs_32 ct_darkblue_text mb-4"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section4", "box1")}
                                            >
                                                {templateData?.section4?.box1}
                                            </h3>
                                            <p
                                                className="ct_darkblue_text ct_text_op_6 mb-0 mx-auto ct_para_scroll ct_custom_scroll"
                                                style={{ maxWidth: "333px" }}
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section4", "title1")}
                                            >
                                                {templateData?.section4?.title1}
                                            </p>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-4">
                                <div className="ct_outline_bg bg-white ct_pb_86 h-100">
                                    <figure className="ct_pt_40 text-center">
                                        <img src="../assets/img/iconamoon_clock-fill.png" />
                                        <figcaption className="ct_mt_60">
                                            <h3
                                                className="ct_fs_32 ct_darkblue_text mb-4"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section4", "box2")}
                                            >
                                                {templateData?.section4?.box2}
                                            </h3>
                                            <p
                                                className="ct_darkblue_text ct_text_op_6 mb-0 mx-auto ct_para_scroll ct_custom_scroll"
                                                style={{ maxWidth: "333px" }}
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section4", "title2")}
                                            >
                                                {templateData?.section4?.title2}
                                            </p>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-4">
                                <div className="ct_outline_bg bg-white ct_pb_86 h-100">
                                    <figure className="ct_pt_40 text-center">
                                        <img src="../assets/img/icon-park-solid_message.png" />
                                        <figcaption className="ct_mt_60">
                                            <h3
                                                className="ct_fs_32 ct_darkblue_text mb-4"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section4", "box3")}
                                            >
                                                {templateData?.section4?.box3}
                                            </h3>
                                            <p
                                                className="ct_darkblue_text ct_text_op_6 mb-0 ct_para_scroll ct_custom_scroll"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section4", "title3")}
                                            >
                                                {templateData?.section4?.title3}
                                            </p>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section class="ct_px_40 ct_expower_shape_new_bg">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-4 mb-4">
                                <div>
                                    <h4
                                        className="ct_fs_32 ct_darkblue_text"
                                        style={{ maxWidth: "220px" }}
                                    >
                                        Empower Your Sales Teams to Sell Bigger, Faster, and Smarter
                                        with Nuvio
                                    </h4>
                                </div>
                            </div>
                            <div className="col-lg-8 mb-4">
                                <div className="row">
                                    <div className="col-md-6 ct_mb_100">
                                        <figure>
                                            <img src="../assets/img/target-icon.png" />
                                            <figcaption className="mt-4">
                                                <h4
                                                    className="ct_fs_22 ct_darkblue_text mb-4"
                                                    style={{ maxWidth: "300px" }}
                                                >
                                                    Focus on What Really Drives Revenue
                                                </h4>
                                                <p
                                                    className="ct_fs_18 mb-0"
                                                    style={{ maxWidth: "319px" }}
                                                >
                                                    Not all leads are created equal. With Nuvio, your sales
                                                    team can confidently prioritize the prospects that bring
                                                    the biggest wins, avoiding wasted effort and zeroing in
                                                    on the opportunities that truly move the needle for your
                                                    business.
                                                </p>
                                            </figcaption>
                                        </figure>
                                    </div>
                                    <div className="col-md-6 ct_mb_100">
                                        <figure>
                                            <img src="../assets/img/setting_icon_set.png" />
                                            <figcaption className="mt-4">
                                                <h4
                                                    className="ct_fs_22 ct_darkblue_text mb-4"
                                                    style={{ maxWidth: "300px" }}
                                                >
                                                    Smooth Out the Entire Sales Journey
                                                </h4>
                                                <p
                                                    className="ct_fs_18 mb-0"
                                                    style={{ maxWidth: "319px" }}
                                                >
                                                    Say goodbye to clunky handoffs, scattered tasks, and
                                                    pipeline slowdowns. Nuvio streamlines every step of the
                                                    sales process, helping your team glide from first
                                                    contact to closed deal with clarity, speed, and
                                                    efficiency every time.
                                                </p>
                                            </figcaption>
                                        </figure>
                                    </div>
                                    <div className="col-md-6 ">
                                        <figure>
                                            <img src="../assets/img/pixel_trophy-solid.png" />
                                            <figcaption className="mt-4">
                                                <h4
                                                    className="ct_fs_22 ct_darkblue_text mb-4"
                                                    style={{ maxWidth: "300px" }}
                                                >
                                                    Empower Your Reps to Close with Confidence
                                                </h4>
                                                <p
                                                    className="ct_fs_18 mb-0"
                                                    style={{ maxWidth: "319px" }}
                                                >
                                                    Winning sales teams don’t just work hard they work
                                                    smart. Nuvio equips your reps with the right tools,
                                                    insights, and support so they show up ready, pitch with
                                                    confidence, and consistently outperform the competition.
                                                </p>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
                <section className="ct_px_40 ct_expower_shape_new_bg">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-4 mb-4">
                                <h4
                                    className="ct_fs_32 ct_darkblue_text"
                                    style={{ maxWidth: "220px" }}
                                // contentEditable
                                // suppressContentEditableWarning
                                // onBlur={(e) => handleChangeValue(e, "section5", "heading")}
                                >
                                    Empower Your Sales Teams to Sell Bigger, Faster, and Smarter with Nuvio
                                </h4>
                            </div>
                            <div className="col-lg-8 mb-4">
                                <div className="row">
                                    {/* CARD 1 */}
                                    <div className="col-md-6 ct_mb_100">
                                        <figure>
                                            <img src="../assets/img/target-icon.png" />
                                            <figcaption className="mt-4">
                                                <h4
                                                    className="ct_fs_22 ct_darkblue_text mb-4"
                                                    style={{ maxWidth: "300px" }}
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section5", "title1")}
                                                >
                                                    {templateData?.section5?.title1}
                                                </h4>
                                                <p
                                                    className="ct_fs_18 mb-0"
                                                    style={{ maxWidth: "319px" }}
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section5", "description1")}
                                                >
                                                    {templateData?.section5?.description1}
                                                </p>
                                            </figcaption>
                                        </figure>
                                    </div>
                                    {/* CARD 2 */}
                                    <div className="col-md-6 ct_mb_100">
                                        <figure>
                                            <img src="../assets/img/setting_icon_set.png" />
                                            <figcaption className="mt-4">
                                                <h4
                                                    className="ct_fs_22 ct_darkblue_text mb-4"
                                                    style={{ maxWidth: "300px" }}
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section5", "title2")}
                                                >
                                                    {templateData?.section5?.title2}
                                                </h4>
                                                <p
                                                    className="ct_fs_18 mb-0"
                                                    style={{ maxWidth: "319px" }}
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section5", "description2")}
                                                >

                                                    {templateData?.section5?.description2}
                                                </p>
                                            </figcaption>
                                        </figure>
                                    </div>
                                    {/* CARD 3 */}
                                    <div className="col-md-6">
                                        <figure>
                                            <img src="../assets/img/pixel_trophy-solid.png" />
                                            <figcaption className="mt-4">
                                                <h4
                                                    className="ct_fs_22 ct_darkblue_text mb-4"
                                                    style={{ maxWidth: "300px" }}
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section5", "title3")}
                                                >
                                                    {templateData?.section5?.title3}

                                                </h4>
                                                <p
                                                    className="ct_fs_18 mb-0"
                                                    style={{ maxWidth: "319px" }}
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section5", "description3")}
                                                >

                                                    {templateData?.section5?.description3}
                                                </p>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* This one  */}
                <section className="ct_px_40 ct_mt_130 ct_pt_60">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <h4
                                    className="ct_fs_32 ct_darkblue_text mb-4"
                                    contentEditable
                                    suppressContentEditableWarning
                                    onBlur={(e) => handleChangeValue(e, "section6", "heading")}
                                >
                                    {templateData?.section6?.heading}
                                </h4>
                                <p
                                    className="mb-0 ct_fs_20 ct_darkblue_text"
                                    style={{ maxWidth: "877px" }}
                                    contentEditable
                                    suppressContentEditableWarning
                                    onBlur={(e) => handleChangeValue(e, "section6", "body")}
                                >
                                    {templateData?.section6?.body}
                                </p>
                            </div>
                        </div>
                        <div className="row ct_mt_60">
                            {/* PLAN 1 */}
                            <div className="col-lg-4 mb-5">
                                <div className="ct_pricing_card" style={{ borderColor: "#8ECAE6" }}>
                                    <div>
                                        <div className="ct_pricing_title mt-3 text-start">
                                            <p
                                                className="ct_mb_16 ct_fs_20 ct_darkblue_text"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section6", "plan1_title")}
                                            >
                                                {templateData?.section6?.plan1_title}
                                            </p>
                                            <h2 className="ct_fs_44 mb-0 ct_darkblue_text">
                                                <span
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section6", "plan1_price")}
                                                >
                                                    {templateData?.section6?.plan1_price}
                                                </span>
                                                <span className="ct_fs_18"> /6 Months </span>
                                            </h2>
                                            <p
                                                className="mb-0 mt-2 ct_fs_18 ct_darkblue_text"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section6", "plan1_description")}
                                            >
                                                {templateData?.section6?.plan1_description}
                                            </p>
                                        </div>
                                        <ul className="ct_mt_30 mb-4 mt-4">
                                            {templateData?.section6?.plan1_points?.map((point, i) => (
                                                <li className="ct_fs_18 d-flex align-items-start gap-2 justify-content-between" key={i}>
                                                    <div className=' d-flex align-items-start gap-2'>
                                                        <i className="fa-solid fa-check" style={{ backgroundColor: "#023047" }}></i>
                                                        <span
                                                            contentEditable
                                                            suppressContentEditableWarning
                                                            onBlur={(e) => {
                                                                const newPoints = [...templateData.section6.plan1_points]
                                                                newPoints[i] = e.target.innerText

                                                                setTemplateData(prev => ({
                                                                    ...prev,
                                                                    section6: {
                                                                        ...prev.section6,
                                                                        plan1_points: newPoints
                                                                    }
                                                                }))
                                                            }}
                                                        >
                                                            {point}
                                                        </span>
                                                    </div>
                                                    <i
                                                        className="fa-solid fa-trash text-danger ms-2"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleDeletePlanPoint("plan1_points", i)}
                                                    ></i>
                                                </li>
                                            ))}
                                        </ul>

                                    </div>
                                    <div className="mt-auto pt-5">
                                        <div className="text-end mb-3">
                                            <span
                                                className="ct_orange_text ct_cursor_pointer"
                                                onClick={() => handleAddPlanPoint("plan1_points")}
                                            >
                                                + Add Point
                                            </span>
                                        </div>
                                        <a className="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                            Get Started
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* PLAN 2 */}
                            <div className="col-lg-4 mb-5">
                                <div className="ct_pricing_card" style={{ borderColor: "#8ECAE6" }}>
                                    <div>
                                        <div className="ct_pricing_title mt-3 text-start">
                                            <p
                                                className="ct_mb_16 ct_fs_20 ct_darkblue_text"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section6", "plan2_title")}
                                            >
                                                {templateData?.section6?.plan2_title}
                                            </p>
                                            <h2 className="ct_fs_44 mb-0 ct_darkblue_text">
                                                <span
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section6", "plan2_price")}
                                                >
                                                    {templateData?.section6?.plan2_price}
                                                </span>
                                                <span className="ct_fs_18"> /12 Months </span>
                                            </h2>
                                            <p
                                                className="mb-0 mt-2 ct_fs_18 ct_darkblue_text"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section6", "plan2_description")}
                                            >
                                                {templateData?.section6?.plan2_description}
                                            </p>
                                        </div>
                                        <ul className="ct_mt_30 mb-4 mt-4">
                                            {templateData?.section6?.plan2_points?.map((point, i) => (
                                                <li className="ct_fs_18 d-flex align-items-start gap-2 justify-content-between" key={i}>
                                                    <div className='d-flex align-items-start gap-2'>
                                                        <i
                                                            className="fa-solid fa-check"
                                                            style={{ backgroundColor: "#023047" }}
                                                        ></i>
                                                        <span
                                                            contentEditable
                                                            suppressContentEditableWarning
                                                            onBlur={(e) => {
                                                                const newPoints = [...templateData.section6.plan2_points]
                                                                newPoints[i] = e.target.innerText

                                                                setTemplateData(prev => ({
                                                                    ...prev,
                                                                    section6: {
                                                                        ...prev.section6,
                                                                        plan2_points: newPoints
                                                                    }
                                                                }))

                                                            }}
                                                        >
                                                            {point}
                                                        </span>
                                                    </div>
                                                    <i
                                                        className="fa-solid fa-trash text-danger ms-2"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleDeletePlanPoint("plan2_points", i)}
                                                    ></i>
                                                </li>
                                            ))}
                                        </ul>

                                    </div>
                                    <div className="mt-auto">
                                        <div className="text-end mb-3">
                                            <span
                                                className="ct_orange_text ct_cursor_pointer"
                                                onClick={() => handleAddPlanPoint("plan2_points")}
                                            >

                                                + Add Point
                                            </span>
                                        </div>
                                        <a className="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                            Get Started
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* PLAN 3 */}
                            <div className="col-lg-4 mb-5">
                                <div className="ct_pricing_card" style={{ borderColor: "#8ECAE6" }}>
                                    <div>
                                        <div className="ct_pricing_title mt-3 text-start">
                                            <p
                                                className="ct_mb_16 ct_fs_20 ct_darkblue_text"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section6", "plan3_title")}
                                            >
                                                {templateData?.section6?.plan3_title}
                                            </p>
                                            <h2 className="ct_fs_44 mb-0 ct_darkblue_text">
                                                <span
                                                    contentEditable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => handleChangeValue(e, "section6", "plan3_price")}
                                                >
                                                    {templateData?.section6?.plan3_price}
                                                </span>
                                                <span className="ct_fs_18"> /36 Months </span>
                                            </h2>
                                            <p
                                                className="mb-0 mt-2 ct_fs_18 ct_darkblue_text"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onBlur={(e) => handleChangeValue(e, "section6", "plan3_description")}
                                            >
                                                {templateData?.section6?.plan3_description}
                                            </p>
                                        </div>
                                        <ul className="ct_mt_30 mb-4 mt-4">
                                            {templateData?.section6?.plan3_points?.map((point, i) => (
                                                <li className="ct_fs_18 d-flex align-items-start gap-2 justify-content-between" key={i}>
                                                    <div className='d-flex align-items-start gap-2'>
                                                        <i
                                                            className="fa-solid fa-check"
                                                            style={{ backgroundColor: "#023047" }}
                                                        ></i>
                                                        <span
                                                            contentEditable
                                                            suppressContentEditableWarning
                                                            onBlur={(e) => {
                                                                const newPoints = [...templateData.section6.plan3_points]
                                                                newPoints[i] = e.target.innerText

                                                                setTemplateData(prev => ({
                                                                    ...prev,
                                                                    section6: {
                                                                        ...prev.section6,
                                                                        plan3_points: newPoints
                                                                    }
                                                                }))

                                                            }}
                                                        >
                                                            {point}
                                                        </span>
                                                    </div>
                                                    <i
                                                        className="fa-solid fa-trash text-danger ms-2"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleDeletePlanPoint("plan3_points", i)}
                                                    ></i>
                                                </li>
                                            ))}
                                        </ul>

                                    </div>
                                    <div className="mt-auto pt-5">
                                        <div className="text-end mb-3">
                                            <span
                                                className="ct_orange_text ct_cursor_pointer"
                                                onClick={() => handleAddPlanPoint("plan3_points")}
                                            >
                                                + Add Point
                                            </span>
                                        </div>
                                        <a className="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                                            Get Started
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    class="ct_looking_for_work_bg  ct_mt_130     ct_p_111_y_106"
                    style={{ backgroundColor: "#8ECAE6" }}
                >
                    <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                        <div class="text-white">
                            <h4 class="ct_fs_36 mb-4 text-white" style={{ maxWidth: "600px" }}>
                                Ready to Find the Perfect Fit for Your Business?
                            </h4>
                            <p class="mb-0 ct_fs_18" style={{ maxWidth: "630px" }}>
                                Explore our tailored packages and discover flexible solutions
                                designed to help you scale faster, sell smarter, and succeed
                                confidently.
                            </p>
                        </div>
                        <div class="ct_flex_shrink_0">
                            <a
                                class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                            >
                                View Combined Packages
                            </a>
                        </div>
                    </div>
                </section>

                <section className="ct_px_40 ct_mt_130">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="ct_fs_32 ct_darkblue_text text-center">
                                    Why Winning Teams Choose Our Sales Solutions
                                </h4>
                            </div>
                        </div>
                        <div className="row ct_mt_60 gx-5">
                            <div className="col-md-4 mb-5">
                                <div className="ct_outline_bg ct_winning_team_card_12">
                                    <figure className="mb-0 ct_mt_70">
                                        <img src="../assets/img/3_direction.png" />
                                        <figcaption className="ct_mt_30">
                                            <p className="ct_fs_24_new">
                                                Empower Teams with Smarter Sales Solutions
                                            </p>
                                            <div className="ct_plus_icon_circle ms-auto">
                                                <i class="fa-solid fa-plus"></i>
                                            </div>
                                            <div className="ct_winning_team_overlay_content">
                                                <ul>
                                                    <li className="d-flex align-items-start gap-2">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            {" "}
                                                            Focus on high-value prospects, prioritize top
                                                            opportunities, and drive meaningful growth.
                                                        </span>
                                                    </li>
                                                    <li className="d-flex align-items-start gap-2 ct_mt_30">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            Automate routine tasks, eliminate bottlenecks, and
                                                            free up your team to focus on closing deals
                                                        </span>
                                                    </li>
                                                    <li className="d-flex align-items-start gap-2 ct_mt_30">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            {" "}
                                                            Focus on high-value prospects, prioritize top
                                                            opportunities, and drive meaningful growth.
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4 mb-5">
                                <div className="ct_outline_bg ct_winning_team_card_12">
                                    <figure className="mb-0 ct_mt_70">
                                        <img src="../assets/img/3_direction.png" />
                                        <figcaption className="ct_mt_30">
                                            <p className="ct_fs_24_new">
                                                Accelerate Sales Performance with the Right Tools
                                            </p>
                                            <div className="ct_plus_icon_circle ms-auto">
                                                <i class="fa-solid fa-plus"></i>
                                            </div>
                                            <div className="ct_winning_team_overlay_content">
                                                <ul>
                                                    <li className="d-flex align-items-start gap-2">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            {" "}
                                                            Equip your team with powerful tools that simplify
                                                            every stage of the sales journey.
                                                        </span>
                                                    </li>
                                                    <li className="d-flex align-items-start gap-2 ct_mt_30">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            Gain real-time insights to track progress, adjust
                                                            strategies, and stay ahead of the competition.
                                                        </span>
                                                    </li>
                                                    <li className="d-flex align-items-start gap-2 ct_mt_30">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            {" "}
                                                            Deliver a seamless experience across teams, ensuring
                                                            everyone works toward the same goals with clarity
                                                            and precision.
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-4 mb-5">
                                <div className="ct_outline_bg ct_winning_team_card_12">
                                    <figure className="ct_mt_70 mb-0">
                                        <img src="../assets/img/solid_dark_setting.png" />
                                        <figcaption className="ct_mt_30">
                                            <p className="ct_fs_24_new">
                                                Unlock Sales Innovation to Stay Ahead
                                            </p>
                                            <div className="ct_plus_icon_circle ms-auto">
                                                <i class="fa-solid fa-plus"></i>
                                            </div>
                                            <div className="ct_winning_team_overlay_content">
                                                <ul>
                                                    <li className="d-flex align-items-start gap-2">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            {" "}
                                                            Adopt forward-thinking strategies that help your
                                                            team adapt in a fast-changing market.
                                                        </span>
                                                    </li>
                                                    <li className="d-flex align-items-start gap-2 ct_mt_30">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            Leverage cutting-edge tools and insights to uncover
                                                            new growth opportunities.
                                                        </span>
                                                    </li>
                                                    <li className="d-flex align-items-start gap-2 ct_mt_30">
                                                        <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                                                        <span>
                                                            {" "}
                                                            Continuously evolve your sales approach to outpace
                                                            competitors and deliver exceptional value.
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class=" ct_px_40 pt-0 ct_mt_80  ">
                    <div class="container-fluid">
                        <div class="row align-items-center">
                            <div class="col-xxl-7 col-xl-6 col-md-6 mb-4 mb-md-0">
                                <div class="ct_about_cnt">
                                    <h2 class="mb-4 ct_fs_32 mb-5 ">Frequently asked questions</h2>
                                    <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                                        <div class="accordion" id="faq_accordionExample">
                                            {templateData?.section8?.faqs?.map((item, i) => (
                                                <div className="d-flex align-items-center gap-2">
                                                    <div class="accordion-item ct_flex_1">
                                                        <h2 class="accordion-header" id={`faq_${i}`}>
                                                            <button
                                                                class="accordion-button collapsed"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapsefaq_one${i}`}
                                                                aria-expanded="false"
                                                                aria-controls={`collapsefaq_one${i}`}
                                                            >
                                                                <span
                                                                    contentEditable={"true"}
                                                                    suppressContentEditableWarning
                                                                    onBlur={(e) =>
                                                                        handleFaqChange(
                                                                            i,
                                                                            "question",
                                                                            e.target.innerText.trim() ||
                                                                            "Enter Question"
                                                                        )
                                                                    }
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === "Enter") {
                                                                            e.preventDefault();
                                                                            e.target.blur();
                                                                        }
                                                                    }}
                                                                    style={{ outline: "none", width: "100%" }}
                                                                >
                                                                    {item?.question || "Enter Question"}
                                                                </span>
                                                            </button>
                                                        </h2>
                                                        <div
                                                            id={`collapsefaq_one${i}`}
                                                            class="accordion-collapse collapse"
                                                            aria-labelledby="faq_one"
                                                            data-bs-parent="#faq_accordionExample"
                                                        >
                                                            <div class="accordion-body">
                                                                <p
                                                                    class="ct_fs_20 mb-3 ct_line_h_30"
                                                                    contentEditable={"true"}
                                                                    suppressContentEditableWarning
                                                                    onBlur={(e) =>
                                                                        handleFaqChange(
                                                                            i,
                                                                            "answer",
                                                                            e.target.innerText.trim()
                                                                        )
                                                                    }
                                                                >
                                                                    {item?.answer != ""
                                                                        ? item?.answer
                                                                        : "Enter Answer"}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {templateData?.section8?.faqs?.length > 1 && (
                                                        <div className="mt-3 ct_cursor_pointer">
                                                            <i
                                                                class="fa-solid fa-trash-can text-danger"
                                                                onClick={() => handleDeleteFaq(i)}
                                                            ></i>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                            <div className="text-end mt-3">
                                                <a
                                                    className="ct_orange_text ct_fw_600"
                                                    onClick={handleAddFaq}
                                                >
                                                    + Add FAQ
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5  ">
                                <div class="ct_about_img">
                                    <label className='d-block'>
                                        <input
                                            className="d-none"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleImageChange(e, "faq")}
                                        />
                                        <img
                                            src={getImageSrc(
                                                imageFiles.faq,
                                                "../assets/img/faq_img_789.png"
                                            )}
                                            style={{
                                                maxWidth: "100%",
                                                ...(imageFiles.faq ? { objectFit: "contain" } : {}),
                                            }}
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    data-aos="fade-right"
                    data-aos-duration="1500"
                    class="ct_looking_for_work_bg ct_looking_for_work_bg_left ct_p_111_y_106 ct_mt_100"
                    style={{ backgroundColor: "#FFB703" }}
                >
                    <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                        <div class="text-white">
                            <h4 class="ct_fs_36 mb-4">Let’s Make Magic Together </h4>
                            <p class="mb-0 ct_fs_18 ct_fw_300">
                                Big ideas, bold moves, and all the support you need we’re here to
                                help you shine.
                            </p>
                        </div>
                        <div class="ct_flex_shrink_0">
                            <a
                                class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                            >
                                Talk to Us
                            </a>
                        </div>
                    </div>
                </section>

                <div style={{ height: "100px" }}></div>
                <div className="text-center mb-5">
                    <button
                        className="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto"
                        type="button"
                    // onClick={handleSubmitForm}
                    >
                        Submit
                    </button>
                </div>
            </AdminLayout>
        </>
    )
}

export default AddServices;
